/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TitleText = styled.span<{ fadeLinesAfterFirst: boolean }>(
  ({ fadeLinesAfterFirst }) => ({
    img: {
      maxHeight: '1em',
      verticalAlign: 'text-bottom',
      '&.emoji': {
        height: '1em',
      },
    },

    'span:not(:first-of-type)': fadeLinesAfterFirst
      ? `color: ${token('color.text.subtlest', colors.N200)}`
      : null,
  })
);
